var React = require('react');

function Gif (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5938 8.84062L5.48125 0H10.5188L15.6313 8.84062H10.5938ZM6.29688 9.57812L3.77813 14H13.4812L16 9.57812H6.29688ZM4.81563 1.10625L0 9.57812L2.51875 14L7.40625 5.525L4.81563 1.10625Z","fill":"#1F1F1F"}));
}

Gif.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = Gif;

Gif.default = Gif;
